import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LogoPrit from "~/assets/images/logo-prit-new-black.png";

const animationStyles = `
	@keyframes slideUp {
		0% {
			opacity: 0;
			transform: translateY(50px);
		}
		100% {
			opacity: 1;
			transform: translateY(0);
		}
	}
	
	@keyframes fadeOut {
		0% {
			opacity: 1;
			transform: translateY(0);
		}
		100% {
			opacity: 0;
			transform: translateY(-20px);
		}
	}
	
	@keyframes wave {
		0% {
			transform: translateX(-100%);
		}
		100% {
			transform: translateX(100%);
		}
	}
	
	@keyframes gradientShift {
		0% {
			background-position: 0% 50%;
		}
		50% {
			background-position: 100% 50%;
		}
		100% {
			background-position: 0% 50%;
		}
	}
	
	@keyframes glow {
		0% {
			box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 0 12px rgba(0, 191, 255, 0.15), 0 0 20px rgba(90, 0, 255, 0.3), 0 0 15px rgba(114, 11, 217, 0.2);
		}
		50% {
			box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 0 20px rgba(0, 191, 255, 0.4), 0 0 30px rgba(90, 0, 255, 0.5), 0 0 25px rgba(114, 11, 217, 0.4);
		}
		100% {
			box-shadow: 0 4px 16px rgba(0,0,0,0.15), 0 0 12px rgba(0, 191, 255, 0.15), 0 0 20px rgba(90, 0, 255, 0.3), 0 0 15px rgba(114, 11, 217, 0.2);
		}
	}
`;

export const VendorSkeleton = ({ isVisible = true, onFadeOutComplete }) => {
	const { t } = useTranslation();
	const [shouldRender, setShouldRender] = useState(true);
	const [isFadingOut, setIsFadingOut] = useState(false);

	useEffect(() => {
		if (!isVisible && shouldRender) {
			setIsFadingOut(true);
			// Aguarda a animação de fade out terminar antes de remover o componente
			const timer = setTimeout(() => {
				setShouldRender(false);
				if (onFadeOutComplete) {
					onFadeOutComplete();
				}
			}, 800); // Duração da animação fadeOut

			return () => clearTimeout(timer);
		}
	}, [isVisible, shouldRender, onFadeOutComplete]);

	// Se não deve renderizar, retorna null
	if (!shouldRender) {
		return null;
	}

	return (
		<>
			<div 
				style={{ 
					display: "flex", 
					flexDirection: "column", 
					height: "100vh", 
					backgroundColor: "#19140E",
					animation: isFadingOut 
						? "fadeOut 0.8s ease-in forwards" 
						: "none"
				}}>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						height: "100vh",
						width: "100%",
					}}>
					<div
						style={{
							position: "relative",
							width: "120px",
							height: "120px",
							borderRadius: "50%",
							overflow: "hidden",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							background: "linear-gradient(90deg, #5A00FF 0%, #00BFFF 50%, #720BD9 100%)",
							backgroundSize: "300% 100%",
							animation: isFadingOut 
								? "fadeOut 0.8s ease-in 0.2s forwards" 
								: "slideUp 1s ease-out 0.3s both, gradientShift 8s ease-in-out infinite, glow 3s ease-in-out infinite",
							boxShadow: "0 4px 16px rgba(0,0,0,0.15), 0 0 12px rgba(0, 191, 255, 0.15), 0 0 20px rgba(90, 0, 255, 0.3), 0 0 15px rgba(114, 11, 217, 0.2)",
						}}>
						{/* Wave effect overlay */}
						<div
							style={{
								position: "absolute",
								top: "0",
								left: "0",
								width: "100%",
								height: "100%",
								background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.1) 20%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.1) 80%, transparent 100%)",
								animation: isFadingOut 
									? "fadeOut 0.6s ease-in 0.3s forwards" 
									: "wave 3s ease-in-out infinite",
								transformOrigin: "center",
							}}
						/>
						{/* Second wave for more dynamic effect */}
						<div
							style={{
								position: "absolute",
								top: "0",
								left: "0",
								width: "100%",
								height: "100%",
								background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.05) 30%, rgba(255,255,255,0.2) 60%, rgba(255,255,255,0.05) 90%, transparent 100%)",
								animation: isFadingOut 
									? "fadeOut 0.5s ease-in 0.4s forwards" 
									: "wave 4s ease-in-out infinite reverse",
								transformOrigin: "center",
							}}
						/>
						<img
							src={LogoPrit}
							alt="Prit Logo"
							style={{
								width: "60px",
								height: "auto",
								zIndex: 2,
								position: "relative",
								filter: "brightness(0) invert(1)", 
								animation: isFadingOut 
									? "fadeOut 0.7s ease-in 0.5s forwards" 
									: "slideUp 1.2s ease-out 0.5s both",
							}}
						/>
					</div>
				</div>
				
				<style>{animationStyles}</style>
			</div>
		</>
	);
};
